<template>
    <el-row ref="top">
        <el-col :span="24" class="mb-5" v-if="showToolbar">
            <slot name="toolbar">
                <slot v-if="(store === 'listacorreos' && emailList) || (store === 'respuestaspredefinidas' && respList) || (store === 'archivos' && attachedList)" name="close">
                    <i class="fas fa-times float-right closePopUpAttached" @click="$emit('closePop')"></i>
                </slot>
                <toolbar :to="to" :icon="icon" :title="title" :create="createAction && !showEditForm" :back="backAction"/>
            </slot>
        </el-col>
        <template v-if="showEditForm">
            <el-col :span="24">
                <toolbar icon="icon-note" :title="(action === 'create' ? $t('create') : $t('edit')) + ' ' + subtitle" save cancel @save="save" @cancel="cancel"/>
            </el-col>
            <el-col :span="24">
                <el-form ref="form" :model="one" :rules="rules" label-position="top" status-icon>
                    <slot></slot>
                </el-form>
            </el-col>
        </template>
        <el-dropdown v-if="showExportButton" @command="exportTo" trigger="click" class="float-right text-primary">
            <span class="el-dropdown-link">
                {{$t('export')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="excel"><i class="far fa-file-excel"></i> Excel</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-col :span="24" class="text-right mb-2">
          <slot name="table-info"></slot>
        </el-col>
        <el-col :span="24">
            <vue-good-table :max-height="(this.store === 'listacorreos' || this.store === 'respuestaspredefinidas' || this.store === 'archivos') ? '50vh' : '100%'" id="vue-good-table" :columns="columnsFormat" :rows="all" :sort-options="sortOptions" styleClass="vgt-table striped">
                <template slot="emptystate">
                    {{$t('withoutRecords')}}
                </template>
                <div slot="table-actions" class="text-right flex">
                    <div>
                        <slot name="table-actions-pre"></slot>
                    </div>
                    <div class="flex mr-1">
                        <div class="selectfilterlog" v-if="store === 'loggeneral'">
                          <el-select :placeholder="$t('historyConfig.filterType')" v-model="filterTypeLog" @change="selectTipoFilterLog">
                              <el-option v-for="tlog in allTipoLog" :key="tlog.id" :label="tlog.name" :value="tlog.id"></el-option>
                          </el-select>
                        </div>
                        <div v-if="store!=='archivos'" class="input-buscar-new" :class="store === 'loggeneral' ? 'blockSearchLog' : ''">
                            <span class="textSearchAct text-warning" v-if="isActiveSearch === 1 && showStyleSearch">{{ $t('case.newSearch.msgActive') }}</span>
                            <i class="fas fa-search icono-buscar-new"></i>
                            <input :placeholder="$t('newSearchInput')" :class="isActiveSearch === 1 && showStyleSearch ? 'activeSearch' : ''" v-model="filtroBuscar" v-on:keyup.enter="newSearchEnter" v-on:keyup="changeSearchEnter" @change="changeSearchEnter"/>
                            <el-button v-if="isStoreCase === 0" class="btn-buscar-new" size="mini" type="primary" @click="newSearchEnter">{{ $t('newSearchBtn') }}</el-button>
                            <div v-if="isStoreCase === 1 && filtroBuscar.length > 0" class="box-btn-buscar">
                              <el-button type="primary" size="mini" icon="fas fa-search" v-tooltip="$t('case.newSearch.search')" @click="newSearchEnter" :disabled="isSearchingCasesButton"></el-button>
                              <el-button type="warning" size="mini" icon="fas fa-eraser" v-tooltip="$t('case.newSearch.clear')" @click="cleanSearch"></el-button>
                            </div>
                        </div>
                        <span v-if="store!=='archivos'">
                        <el-button type="default" class="mt-2 btn-update" size="mini" icon="fas fa-sync-alt" v-tooltip="$t('vtool.update')" @click="getAll(true);emitResetIntervalFromChild()" v-if="refreshAction"></el-button>
                        </span>
                    </div>
                    <div class="mt-2">
                        <slot name="table-actions-post"></slot>
                    </div>
                    <el-button style="height:28px;margin-top:8px" type="success" size="mini" icon="fas fa-globe" v-tooltip="$t('showAll')" v-if="filterAll" @click="filterAlls()"></el-button>
                    <el-button style="height:28px;margin-top:8px" type="info" size="mini" icon="fas fa-id-card" v-tooltip="$t('filterbyContact')" v-if="filterContact" @click="filterContactos()"></el-button>
                    <el-button style="height:28px;margin-top:8px" type="warning" size="mini" icon="fas fa-user" v-tooltip="$t('filterbyUser')" v-if="filterUser" @click="filterUsuarios()"></el-button>
                </div>
                <template slot="table-column" slot-scope="props">
                    <slot :name="'table-column-' + props.column.field" :props="props">{{ props.column.label }}</slot>
                </template>
                <template slot="table-row" slot-scope="props">
                    <template v-if="props.column.field === 'actions'">
                        <div class="whitespace-no-wrap">
                            <slot name="table-row-actions" :props="props"></slot>
                            <el-button :type="toEdit === props.row.id ? 'warning' : 'info'" size="mini" :icon="!editPermissions.modificar && editPermissions.ver ? 'fas fa-search' : 'fas fa-pen'" v-tooltip="$t('vtool.modify')" @click="edit(props.row)" v-if="editAction  && (editPermissions.modificar || editPermissions.ver)"></el-button>
                            <el-button :type="toDestroy === props.row.id ? 'warning' : 'danger'" size="mini" :icon="toDestroy === props.row.id ? 'fas fa-exclamation-circle' : 'far fa-trash-alt'" v-tooltip="$t('vtool.remove')" @click="destroy(props.row.id)" v-if="deleteAction && destroyPermissions"></el-button>
                        </div>
                    </template>
                    <slot :name="'table-row-' + props.column.field" :props="props" v-else>{{ props.formattedRow[props.column.field] }} </slot>
                </template>
            </vue-good-table>
            <template>
                <div class="block paginacion text-right" :key="selectedPage" v-if="store!=='archivos'">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :prev-text="$t('prevText')"
                            :next-text="$t('nextText')"
                            :page-sizes="[10, 15, 50, 100]"
                            :page-size="rowsOnPage"
                            layout="prev, pager, next, slot"
                            :total="this.pagination != undefined && this.pagination != null ? this.pagination.size : 0"
                            :current-page="selectedPage"
                            >
                            <slot name="layout">
                                 <el-dropdown trigger="click" @command="command" style="float: left">
                                    <span class="el-dropdown-link" >
                                        {{rowsOnPage}}/{{$t('pagina')}}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown"  class="el-dropdown-pagination">
                                        <el-dropdown-item v-for="pag of paginationOptions.perPageDropdown" :key="pag" :command="pag">{{pag}}/{{$t('pagina')}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </slot>
                    </el-pagination>
                </div>
            </template>
        </el-col>
    </el-row>
</template>

<style lang="scss">
    @import '~vue-good-table/dist/vue-good-table.css';

    .selectfilterlog {
      margin-right: 5px;

        .el-input__inner {
            height: 37px;
            margin-top: 3px;
            border-radius: 3px;
        }
    }

    .input-buscar {
        width: 100%;
        height: 40px;
        position: relative;
        margin-right: 15px;

        input {
            border-radius: 2px;
            width: 100%;
            height: 40px;
            border: 0;
            border-bottom: 1px solid #e9e9e9;
            padding: 0 40px 0 10px;

            &:focus {
                outline: none;
            }
        }

        .icono-buscar {
            position: absolute;
            right: 10px;
            top: 13px;
            font-size: 15px;
        }

        .icono-buscar-new {
          position: absolute;
          right: 2px;
          top: 3px;
          font-size: 15px;
          padding: 10px;
          cursor: pointer;
        }
    }

    /* borrar cuando se haga filtro buscar en loggeneral*/
    .blockSearchLog {
      pointer-events: none;
      opacity: .4;
    }
    /* borrar */

    .input-buscar-new {
        width: 100%;
        height: 40px;
        position: relative;
        margin-right: 15px;
        margin-top: 3px;

        .textSearchAct {
          font-size: 12px;
          position: absolute;
          top: -15px;
          right: 1px;
        }

        .activeSearch {
          background-color: #f4f4f4;
          border-color: #cf7f01;
          color: #5c5c5c;
        }

        input {
            border-radius: 3px;
            width: 100%;
            height: 37px;
            border: 1px solid #e9e9e9;
            padding: 0 70px 0 35px;

            &:focus {
                outline: none;
            }
        }

        .icono-buscar-new {
          position: absolute;
          left: 12px;
          top: 13px;
          font-size: 12px;
        }

        .btn-buscar-new {
          position: absolute;
          right: 5px;
          top: 5px;
        }

        .box-btn-buscar {
          position: absolute;
          right: 5px;
          top: 4px;
        }
    }

    .vgt-global-search {
        border: 0 !important;
        background: none !important;

        .vgt-global-search__input {
            @apply p-0;

            .input__icon {
                position: absolute;
                top: 0;
                right: 15px;
                max-width: 32px;
                left: inherit;
            }

            .vgt-pull-left {
                float: right !important;
            }

            .vgt-input {
                width: 100%;
                background-color: #fff;
                border: 0;
                border-bottom: 1px solid config('colors.grey-light') !important;
                border-radius: 4px;
                -webkit-box-shadow: none;
                box-shadow: none;
                color: #565656;
                height: 30px;
                max-width: 100%;
                padding: 7px 40px 7px 10px;
                -webkit-transition: all 300ms linear 0s;
                transition: all 300ms linear 0s;

                &:focus {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    border-color: #b7b7b7;
                }

                @screen sm {
                    width: 70%;
                }
                @screen lg {
                    width: 40%;
                }
            }
        }
    }

    .vgt-table {
        border: 0 !important;
        font-size: 14px !important;

        &.striped tbody tr:nth-of-type(odd) {
            @apply bg-grey-lightest;
        }

        thead th {
            @apply border-b bg-grey-light;
            background: none !important;
        }

        tbody td {
            vertical-align: middle !important;
            border-bottom: 0 !important;
        }
    }

    .vgt-wrap__actions-footer {
        @apply border-0 border-b bg-grey-light;
    }

    .vgt-wrap__footer {
        border: 0 !important;
        background: none !important;
    }

    .inp-busqueda {
        .el-input__inner {
            border: 0;
            border-bottom: 1px solid #dae1e7;
        }
    }

    .el-input-group__append {
        border: 0 !important;
        border-bottom: 1px solid #dae1e7 !important;
    }

    .el-input-group__append .el-button:focus {
        outline: none !important;
    }

    .paginacion {
        margin-top: 15px;
        .el-pager li {
            border-radius: 2px;
            color: #b2b2b2;
            min-width: 0px !important;
        }

        .el-pager li number {
            margin: 0 1px;
        }

        .el-pager li.active {
            color: #037a8d;
        }
        .el-pagination {
            font-weight: inherit!important;
        }

        .el-pagination .btn-next {
            padding-left: 0 !important;
            margin-left: 10px;
            border-radius: 2px;
        }

        .el-pagination .btn-prev {
            padding-right: 0 !important;
            margin-right: 10px;
            border-radius: 2px;
        }
        .el-pagination__sizes {
            float: left;
        }

        .el-pagination button {
            padding: 0 !important;
        }

        .el-pagination .el-select .el-input .el-input__inner {
            padding-right: 25px;
            border-radius: 3px;
            border: 0;
        }

    }

    .btn-update {
        //height: 30.3px!important;
    }
    .closePopUpAttached{
        cursor:pointer;
    }

    @media screen and (max-width: 1366px) {
        .btn-update {
            height: 28.2px!important;
        }
    }
    .el-dropdown-pagination{
        z-index: 13000!important;
    }
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import { toExcel, toPdf } from '@/util/exporter'
import { mapActions, mapGetters } from 'vuex'
import isObject from 'lodash/isObject'

export default {
  components: {
    VueGoodTable
  },
  props: {
    autoInit: {
      type: Boolean,
      default: true
    },
    to: {
      type: Object,
      required: false,
      default: null
    },
    showToolbar: {
      type: Boolean,
      default: true,
      required: false
    },
    showEditForm: {
      type: Boolean,
      default: false,
      required: false
    },
    appendData: {
      type: Object,
      required: false,
      default: () => ({})
    },
    icon: {
      type: String,
      default: 'icon-doc',
      required: false
    },
    title: {
      type: String,
      default: '',
      required: false
    },
    subtitle: {
      type: String,
      default: '',
      required: false
    },
    columns: {
      type: Array,
      required: true
    },
    store: {
      type: String,
      required: true
    },
    query: {
      type: Object,
      required: false,
      default: () => ({})
    },
    data: {
      type: Array,
      required: false
    },
    rules: {
      type: Object,
      required: false,
      default: () => ({})
    },
    createAction: {
      type: Boolean,
      default: true
    },
    editAction: {
      type: Boolean,
      default: true
    },
    deleteAction: {
      type: Boolean,
      default: true
    },
    refreshAction: {
      type: Boolean,
      default: true
    },
    backAction: {
      type: Boolean,
      default: false
    },
    sortOptions: {},
    searchable: {
      type: Boolean,
      default: true
    },
    paginable: {
      type: Boolean,
      default: true
    },
    showExportButton: {
      type: Boolean,
      default: false
    },
    propForce: {
      type: Boolean,
      default: false
    },
    filtro: {
      type: String,
      required: false,
      default: null
    },
    queryDateFilter: {
      type: Object,
      required: false,
      default: () => ({})
    },
    filterAll: {
      type: Boolean,
      default: false
    },
    filterContact: {
      type: Boolean,
      default: false
    },
    filterUser: {
      type: Boolean,
      default: false
    },
    contactId: {
      type: Number,
      required: false
    },
    accountId: {
      type: Number,
      required: false
    },
    respList: {
      type: String,
      required: false
    },
    emailList: {
      type: String,
      required: false
    },
    attachedList: {
      type: String,
      required: false
    },
    errorOnSave: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      intervalId: null,
      allTipoLog: [
        { id: 0, name: this.$t('historyConfig.typeAll') },
        { id: 1, name: this.$t('historyConfig.typeWF') },
        { id: 2, name: this.$t('historyConfig.typeStage') },
        { id: 3, name: this.$t('historyConfig.typeScript') },
        { id: 4, name: this.$t('historyConfig.typeDeployment') },
        { id: 5, name: this.$t('historyConfig.typeDeploymentAuthorization') },
        { id: 6, name: this.$t('historyConfig.typeDeploymentConfirmation') },
        { id: 7, name: this.$t('historyConfig.typeDeploymentRollback') },
      ],
      filterTypeLog: 0,
      toEdit: null,
      toDestroy: null,
      searchOptions: {
        enabled: this.searchable,
        placeholder: this.$t('searchFor')
      },
      paginationOptions: {
        enabled: this.paginable,
        mode: 'records',
        perPage: 10,
        position: 'bottom',
        perPageDropdown: [10, 15, 50, 100],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        extLabel: this.$t('next'),
        prevLabel: this.$t('previous'),
        rowsPerPageLabel: this.$t('recordsPerPage'),
        ofLabel: this.$t('of'),
        pageLabel: this.$t('page'),
        allLabel: this.$t('all')
      },
      selectedPage: 1,
      rowsOnPage: 10,
      totalRows: 300,
      filtroBuscar: '',
      timeout: null,
      paginaSelect: 10,
      showStyleSearch: false,
      listcorreos: false,
      isSearchingCasesButton: false,
    }
  },
  computed: {
    all () {
      return this.data || this.$store.getters[`${this.store}/all`]
    },
    one () {
      return this.$store.getters[`${this.store}/one`]
    },
    pagination () {
      return this.$store.getters[`${this.store}/pagination`]
    },
    paginationSelectedKeep () {
      return this.$store.getters[`${this.store}/paginationSelectedKeep`]
    },
    paginationContactKeep () { // Para mantener n° de paginacion al entrar al detalle del contacto
      return this.$store.getters[`${this.store}/paginationContactKeep`]
    },
    // adpv
    paginationAccountKeep () {
      return this.$store.getters[`${this.store}/paginationAccountKeep`]
    },
    paginationUserKeep () {
      return this.$store.getters[`${this.store}/paginationUserKeep`]
    },
    pagiantionRespuestaspredefinidasKeep () {
      return this.$store.getters[`${this.store}/pagiantionRespuestaspredefinidasKeep`]
    },
    // fin adpv
    action () {
      return this.toEdit > 0 ? 'edit' : 'create'
    },
    editPermissions () {
      const route = this.to ? this.to.name.replace('.nuevo', '.editar') : this.$route.name
      return { modificar: this.$getPermission('modificar', route), ver: this.$getPermission('ver', route) }
    },
    destroyPermissions () {
      const route = this.to ? this.to.name.replace('.nuevo', '') : this.$route.name
      return this.$getPermission('eliminar', route)
    },
    purecloud () {
      return this.$route.matched.some(record => record.meta.purecloud)
    },
    idContacto () {
      return this.contactId
    },
    idCuenta () {
      return this.accountId
    },
    isActiveSearch () {
      if (this.$store.state.casos.searchCaseKeep) {
        return 1
      } else if (this.$store.state.contactos.searchContactKeep) {
        return 1
      } else if (this.$store.state.cuentas.searchAccountKeep) {
        return 1
      } else if (this.$store.state.usuarios.searchUserKeep) {
        return 1
      } else if (this.$store.state.respuestaspredefinidas.searchRespuestaspredefinidasKeep) {
        return 1
      } else {
        return 0
      }
    },
    isStoreCase () {
      const array = this.store.split('/')
      if (array.includes('casos') === false && this.store !== 'contactos' && this.store !== 'cuentas' && this.store !== 'usuarios' && this.store !== 'respuestaspredefinidas' && this.store !== 'catalogodocumentos') {
        return 0
      } else {
        return 1
      }
    },
    queryDateFilterSA () {
      const querySA = {
        pagina: 1,
        cantidad: 10,
        filtrobuscar: this.filtroBuscar,
        fechaDesde: this.queryDateFilter.query.fechaDesde,
        fechaHasta: this.queryDateFilter.query.fechaHasta,
        tipoFiltro: this.queryDateFilter.query.tipoFiltro,
        sinasignar: 1
      }

      return Object.assign({}, { force: true, query: querySA }, {})
    },
    columnsFormat () {
      const array = ['cantidadstages', 'id', 'estado']

      const check = this.columns.map((column) => {
        for (const item of array) {
          if (column.field === item) {
            column.type = 'number'
            return column
          }
        }
        return column
      })
      return check
    },
    newQuery () {
      let object = {}
      if (this.query.query) {
        if (Object.keys(this.query.query)[0] === 'idcuenta' || Object.keys(this.query.query)[0] === 'idcontacto') {
          const index = Object.keys(this.query.query)[0]
          if (this.filtroBuscar) {
            object = {
              [index]: this.query.query[Object.keys(this.query.query)[0]],
              pagina: this.selectedPage,
              cantidad: this.rowsOnPage,
              filtrobuscar: this.filtroBuscar
            }
          } else {
            object = {
              [index]: this.query.query[Object.keys(this.query.query)[0]],
              pagina: this.selectedPage,
              cantidad: this.rowsOnPage
            }
          }
          return object
        } else if (Object.keys(this.query.query)[0] === 'origen' && Object.keys(this.query.query)[1] === 'activo') {
          if (this.filtroBuscar) {
            object = {
              origen: this.query.query[Object.keys(this.query.query)[0]],
              activo: this.query.query[Object.keys(this.query.query)[1]],
              pagina: this.selectedPage,
              cantidad: this.rowsOnPage,
              filtrobuscar: this.filtroBuscar
            }
          } else {
            object = {
              origen: this.query.query[Object.keys(this.query.query)[0]],
              activo: this.query.query[Object.keys(this.query.query)[1]],
              pagina: this.selectedPage,
              cantidad: this.rowsOnPage
            }
          }
          return object
        } else if (Object.keys(this.query.query)[0] === 'activo' && this.store === 'listacorreos') {
          if (this.filtroBuscar) {
            object = {
              activo: this.query.query[Object.keys(this.query.query)[0]],
              pagina: this.selectedPage,
              cantidad: this.rowsOnPage,
              filtrobuscar: this.filtroBuscar
            }
          } else {
            object = {
              activo: this.query.query[Object.keys(this.query.query)[0]],
              pagina: this.selectedPage,
              cantidad: this.rowsOnPage
            }
          }
          return object
        } else if (this.store === 'archivos') {
          if (this.filtroBuscar) {
            object = {
              idobjeto: this.query.query[Object.keys(this.query.query)[0]],
              tipoobjeto: this.selectedPage
            }
          } else {
            object = {
              idobjeto: this.query.query[Object.keys(this.query.query)[0]],
              tipoobjeto: this.query.query[Object.keys(this.query.query)[1]]
            }
          }
          return object
        }
      } else {
        return false
      }
    },
    refreshCases: {
      get () {
        return isObject(this.allParametros.find(item => item.key === 'ACTIVE_REFRESH_CASES')) ? this.allParametros.find(item => item.key === 'ACTIVE_REFRESH_CASES').value : ''
      },
      set (data) {
        this.allParametros.find(item => item.key === 'ACTIVE_REFRESH_CASES').value = data
      }
    },
    refreshCasesInterval: {
      get () {
        return isObject(this.allParametros.find(item => item.key === 'TIME_REFRESH_CASES')) ? this.allParametros.find(item => item.key === 'TIME_REFRESH_CASES').value : ''
      },
      set (data) {
        this.allParametros.find(item => item.key === 'TIME_REFRESH_CASES').value = data
      }
    },
    ...mapGetters('parametros', { allParametros: 'all' })
  },
  methods: {
    ...mapActions('contactos', { getByContacts: 'getByContacts' }),
    getAll (force) {
      if (this.propForce) {
        force = true
      }
      if (this.store === 'actividadesprogramadas/sinasignacion') {
        if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
        } else if (this.filtroBuscar.length === 0) {
        }
        const returnData = this.$store.dispatch(`${this.store}/getAll`, this.queryDateFilterSA)
          .then(() => {
            if (this.pagination == null || this.pagination == undefined) {
              return []
            } else {
              const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
              if (this.selectedPage > newPages) {
                this.selectedPage = 1
                this.$store.dispatch(`${this.store}/getAll`, this.queryDateFilterSA)
              }
            }
          })
          .catch(() => this.$notification('error'))
        return returnData
      } else if (this.newQuery != false) {
        let params = ''
        if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
          params = Object.assign({}, { force: true, query: this.newQuery }, {})
        } else if (this.filtroBuscar.length === 0) {
          params = Object.assign({}, { force: true, query: this.newQuery }, {})
        }
        const returnData = this.$store.dispatch(`${this.store}/getAll`, params)
        
          .then((data) => {
            if (this.store === 'usuarios/myteamusers') {
            console.log('entra a if por store usuarios myteam')
                 this.$emit('users-loaded', data)
          }
            if (this.pagination == null || this.pagination == undefined) {
              return []
            } else {
              const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
              if (this.selectedPage > newPages) {
                this.selectedPage = 1
                params = Object.assign({}, { force: true, query: this.newQuery }, {})
                this.$store.dispatch(`${this.store}/getAll`, params)
              }
            }
          })
          .catch(() => this.$notification('error'))
          
        return returnData
      } else {   //if-else principal
        if (this.store === 'loggeneral') {
          var params = ''
          if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
            params = Object.assign({}, { force: !!force, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtrolog: this.filterTypeLog } }, this.query || {})
          } else if (this.filtroBuscar.length === 0) {
            params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrolog: this.filterTypeLog } }, this.query || {})
          }
          const returnData = this.$store.dispatch(`${this.store}/getAll`, params)
            .then(() => {
              if (this.pagination == null || this.pagination == undefined) {
                return []
              } else {
                if (this.pagination.size > 0) {
                  const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
                  if (this.selectedPage > newPages) {
                    this.selectedPage = 1
                    params = Object.assign({}, { force: !!force, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtrolog: this.filterTypeLog } }, this.query || {})
                    this.$store.dispatch(`${this.store}/getAll`, params)
                  }
                }
              }
            })
            .catch(() => this.$notification('error'))
          return returnData
        } else {
          var params = ''
          // begin: mantener la paginacion si esta volviendo de vista editar caso
          if (this.paginationSelectedKeep && this.paginationSelectedKeep.from === 'edit') {
            this.rowsOnPage = this.paginationSelectedKeep.rowsOnPage
            this.selectedPage = this.paginationSelectedKeep.selectedPage
          }
          // end
          // Mantiene la paginacion si esta volviendo de detalle del contacto
          if (this.paginationContactKeep && this.paginationContactKeep.from === 'edit') {
            this.rowsOnPage = this.paginationContactKeep.rowsOnPage
            this.selectedPage = this.paginationContactKeep.selectedPage
          }
          // adpv
          if (this.paginationAccountKeep && this.paginationAccountKeep.from === 'edit') {
            this.rowsOnPage = this.paginationAccountKeep.rowsOnPage
            this.selectedPage = this.paginationAccountKeep.selectedPage
          }
          if (this.paginationUserKeep && this.paginationUserKeep.from === 'edit') {
            this.rowsOnPage = this.paginationUserKeep.rowsOnPage
            this.selectedPage = this.paginationUserKeep.selectedPage
          }
          // fin adpv
          if (this.store === 'casos') {
            this.$store.commit('casos/setSearchCaseKeep', this.filtroBuscar)
          }
          if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
            params = Object.assign({}, { force: !!force, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
          } else if (this.filtroBuscar.length === 0) {
            params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
          }
          const returnData = this.$store.dispatch(`${this.store}/getAll`, params)
            .then((data) => {
              if (this.store === 'usuarios/myteamusers') {
            console.log('entra a if por store usuarios myteam')
                 this.$emit('users-loaded', data)
          }
              // begin: se guardan los parametros seleccionados
              if (this.paginationSelectedKeep) {
                this.paginationSelectedKeep.rowsOnPage = this.rowsOnPage
                this.paginationSelectedKeep.selectedPage = this.selectedPage
                this.paginationSelectedKeep.from = 'list' // tipo para difrenciar si viene desde editar casos
              }
              // end
              // Mantiene la paginacion si esta volviendo de detalle del contacto
              if (this.paginationContactKeep) {
                this.paginationContactKeep.rowsOnPage = this.rowsOnPage
                this.paginationContactKeep.selectedPage = this.selectedPage
                this.paginationContactKeep.from = 'list' // Indicador para difrenciar si viene desde editar contacto
              }
              // end
              // adpv
              if (this.paginationAccountKeep) {
                this.paginationAccountKeep.rowsOnPage = this.rowsOnPage
                this.paginationAccountKeep.selectedPage = this.selectedPage
                this.paginationAccountKeep.from = 'list'
              }
              if (this.paginationUserKeep) {
                this.paginationUserKeep.rowsOnPage = this.rowsOnPage
                this.paginationUserKeep.selectedPage = this.selectedPage
                this.paginationUserKeep.from = 'list'
              }

              // fin adpv

              if (this.pagination == null || this.pagination == undefined) {
                return []
              } else {
                if (this.pagination.size > 0) {
                  const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
                  if (this.selectedPage > newPages) {
                    this.selectedPage = 1
                    params = Object.assign({}, { force: !!force, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
                    this.$store.dispatch(`${this.store}/getAll`, params)
                  }
                }
              }


            })
            .catch(() => this.$notification('error'))

           
          return returnData
        }
      } //fin else principal
    },
    getAllORIGINAL (force) {
      if (this.propForce) {
        force = true
      }
      if (this.store === 'actividadesprogramadas/sinasignacion') {
        if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
        } else if (this.filtroBuscar.length === 0) {
        }
        const returnData = this.$store.dispatch(`${this.store}/getAll`, this.queryDateFilterSA)
          .then(() => {
            if (this.pagination == null || this.pagination == undefined) {
              return []
            } else {
              const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
              if (this.selectedPage > newPages) {
                this.selectedPage = 1
                this.$store.dispatch(`${this.store}/getAll`, this.queryDateFilterSA)
              }
            }
          })
          .catch(() => this.$notification('error'))
        return returnData
      } else if (this.newQuery != false) {
        let params = ''
        if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
          params = Object.assign({}, { force: true, query: this.newQuery }, {})
        } else if (this.filtroBuscar.length === 0) {
          params = Object.assign({}, { force: true, query: this.newQuery }, {})
        }
        const returnData = this.$store.dispatch(`${this.store}/getAll`, params)
          .then((data) => {
            if (this.store === 'usuarios/myteamusers') {            
                 this.$emit('users-loaded', data)
            }
            if (this.pagination == null || this.pagination == undefined) {
              return []
            } else {
              const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
              if (this.selectedPage > newPages) {
                this.selectedPage = 1
                params = Object.assign({}, { force: true, query: this.newQuery }, {})
                this.$store.dispatch(`${this.store}/getAll`, params)
              }
            }
          })
          .catch(() => this.$notification('error'))
        return returnData
      } else {
        if (this.store === 'loggeneral') {
          var params = ''
          if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
            params = Object.assign({}, { force: !!force, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtrolog: this.filterTypeLog } }, this.query || {})
          } else if (this.filtroBuscar.length === 0) {
            params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrolog: this.filterTypeLog } }, this.query || {})
          }
          const returnData = this.$store.dispatch(`${this.store}/getAll`, params)
            .then(() => {
              if (this.pagination == null || this.pagination == undefined) {
                return []
              } else {
                if (this.pagination.size > 0) {
                  const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
                  if (this.selectedPage > newPages) {
                    this.selectedPage = 1
                    params = Object.assign({}, { force: !!force, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtrolog: this.filterTypeLog } }, this.query || {})
                    this.$store.dispatch(`${this.store}/getAll`, params)
                  }
                }
              }
            })
            .catch(() => this.$notification('error'))
          return returnData
        } else {
          var params = ''
          // begin: mantener la paginacion si esta volviendo de vista editar caso
          if (this.paginationSelectedKeep && this.paginationSelectedKeep.from === 'edit') {
            this.rowsOnPage = this.paginationSelectedKeep.rowsOnPage
            this.selectedPage = this.paginationSelectedKeep.selectedPage
          }
          // end
          // Mantiene la paginacion si esta volviendo de detalle del contacto
          if (this.paginationContactKeep && this.paginationContactKeep.from === 'edit') {
            this.rowsOnPage = this.paginationContactKeep.rowsOnPage
            this.selectedPage = this.paginationContactKeep.selectedPage
          }
          // adpv
          if (this.paginationAccountKeep && this.paginationAccountKeep.from === 'edit') {
            this.rowsOnPage = this.paginationAccountKeep.rowsOnPage
            this.selectedPage = this.paginationAccountKeep.selectedPage
          }
          if (this.paginationUserKeep && this.paginationUserKeep.from === 'edit') {
            this.rowsOnPage = this.paginationUserKeep.rowsOnPage
            this.selectedPage = this.paginationUserKeep.selectedPage
          }
          // fin adpv
          if (this.store === 'casos') {
            this.$store.commit('casos/setSearchCaseKeep', this.filtroBuscar)
          }
          if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
            params = Object.assign({}, { force: !!force, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
          } else if (this.filtroBuscar.length === 0) {
            params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
          }
          const returnData = this.$store.dispatch(`${this.store}/getAll`, params)
            .then(() => {
              if (this.store === 'usuarios/myteamusers') {           
                 this.$emit('users-loaded', data)
              }
              // begin: se guardan los parametros seleccionados
              if (this.paginationSelectedKeep) {
                this.paginationSelectedKeep.rowsOnPage = this.rowsOnPage
                this.paginationSelectedKeep.selectedPage = this.selectedPage
                this.paginationSelectedKeep.from = 'list' // tipo para difrenciar si viene desde editar casos
              }
              // end
              // Mantiene la paginacion si esta volviendo de detalle del contacto
              if (this.paginationContactKeep) {
                this.paginationContactKeep.rowsOnPage = this.rowsOnPage
                this.paginationContactKeep.selectedPage = this.selectedPage
                this.paginationContactKeep.from = 'list' // Indicador para difrenciar si viene desde editar contacto
              }
              // end
              // adpv
              if (this.paginationAccountKeep) {
                this.paginationAccountKeep.rowsOnPage = this.rowsOnPage
                this.paginationAccountKeep.selectedPage = this.selectedPage
                this.paginationAccountKeep.from = 'list'
              }
              if (this.paginationUserKeep) {
                this.paginationUserKeep.rowsOnPage = this.rowsOnPage
                this.paginationUserKeep.selectedPage = this.selectedPage
                this.paginationUserKeep.from = 'list'
              }

              // fin adpv

              if (this.pagination == null || this.pagination == undefined) {
                return []
              } else {
                if (this.pagination.size > 0) {
                  const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
                  if (this.selectedPage > newPages) {
                    this.selectedPage = 1
                    params = Object.assign({}, { force: !!force, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
                    this.$store.dispatch(`${this.store}/getAll`, params)
                  }
                }
              }
            })
            .catch(() => this.$notification('error'))
          return returnData
        }
      }
    },
    getBy (id) {
      return this.$store.dispatch(`${this.store}/getBy`, { id }).catch(() => this.$notification('error'))
    },
    save () {
      this.$validateForm('form').then(valid => {
        if (valid) {
          if (this.store === 'listacorreos') {
            this.one.casilla = this.one.casilla.replace(/\s+/g, '')
            this.one.casilla = this.one.casilla.replace(/,/g, ', ')
          }
          Object.assign(this.one, this.appendData)
          this.$store.dispatch(`${this.store}/save`)
            .then(() => {
              this.cancel()
              this.$emit('after-save', true)
              this.$notification('success')
            })
            .catch((error) => {
              this.$emit('after-save', false)
              if (this.errorOnSave) {
                this.$notification('error', error.response.data.message)
              } else {
                this.$notification('error')
              }
            })
        }
      })
    },
    edit (item) {
      if (this.showEditForm) {
        if (this.toEdit !== item.id) {
          this.toEdit = item.id
          this.getBy(item.id)
        } else {
          this.cancel()
        }
      } else {
        // Indicador para señalar si viene desde editar contacto
        if (this.store === 'contactos') {
          this.paginationContactKeep.from = 'edit'
        }
        // adpv
        if (this.store === 'cuentas') {
          this.paginationAccountKeep.from = 'edit'
        }
        if (this.store === 'usuarios') {
          this.paginationUserKeep.from = 'edit'
        }
        // fin adpv
        if (this.store === 'contactos' || this.store === 'gruposkill' || this.store === 'cuentas') { // llamo getBy
          this.$store.dispatch(`${this.store}/getByGlobal`, { id: item.id }).then((data) => {
            const route = `${this.$route.path}/editar/${item.id}`
            this.$router.push(route)
          })
        } else {
          const route = this.to ? { name: this.to.name.replace('.nuevo', '.editar'), params: { id: item.id } } : `${this.$route.path}/editar/${item.id}`
          this.$router.push(route)
        }
      }
    },
    destroy(id) {    
      this.$confirm(this.$t('destroyMessageRegister'), this.$t('danger'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
      .then(() => {
        // Espera a que la acción de eliminar se complete
        if(this.store === 'usuarios/myteamusers'){
          return this.$store.dispatch('usuarios/destroy', { id })
        }
        return this.$store.dispatch(this.store + '/destroy', { id });
      })
      .then(() => {
        // Muestra el mensaje de éxito si la solicitud fue exitosa
        this.$message({
          type: 'success',
          message: this.$t('erasedRegister')
        });
      })
      .catch(error => {
        // Muestra el mensaje de error en caso de que la solicitud falle
        // Si el error es la cancelación, se maneja aquí
        if (error === 'cancel') {
          this.$message({
            type: 'info',
            message: this.$t('canceledAction')
          });
        } else {
          // Muestra el mensaje de error del servidor si la solicitud falla
          this.$message({
            type: 'error',
            message: error.response ? error.response.data.message : this.$t('error')
          });
        }
      });
    },
    cancel () {
      this.getBy(0).then(() => {
        this.toEdit = null
        this.$resetForm('form')
      })
    },
    exportTo (command) {
      if (command === 'pdf') {
        toPdf(this.all, this.title, this.columns, 'datatable')
      }
      if (command === 'excel') {
        toExcel(this.all, this.title, this.columns, 'datatable')
      }
    },
    handleCurrentChange (val) {
      this.selectedPage = val
      this.getAll(true)
      this.emitResetIntervalFromChild();
    },
    handleSizeChange (val) {
      this.rowsOnPage = val
      this.selectedPage = 1
      this.current_page = 1
      this.getAll(true)
    },
    searchTimeOut () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getAll(true)
      }, 500)
    },
    command (val) {
      this.rowsOnPage = val
      this.selectedPage = 1
      this.current_page = 1
      this.getAll(true)
      this.emitResetIntervalFromChild();
    },
    filterAlls () {
      const params = Object.assign({}, { force: true, query: { cantidad: 10, pagina: 1 } })
      this.$store.dispatch('gruposkill/getAll', params)
    },
    filterContactos () {
      const params = Object.assign({}, { force: true, query: { tipo: 2, cantidad: 10, pagina: 1 } })
      this.$store.dispatch('gruposkill/getAll', params)
    },
    filterUsuarios () {
      const params = Object.assign({}, { force: true, query: { tipo: 1, cantidad: 10, pagina: 1 } })
      this.$store.dispatch('gruposkill/getAll', params)
    },
    cleanSearch () {
      this.emitResetIntervalFromChild();
      if (this.filtroBuscar.length > 0 && (this.store === 'casos' || this.store === 'casos/grupo' || this.store === 'casos/gruposkill' || this.store === 'contactos/casos' || this.store === 'cuentas/casos')) {
        this.$store.commit('casos/setSearchCaseKeep', '')
        this.$set(this, 'filtroBuscar', '')
        this.$set(this, 'selectedPage', 1)
        this.showStyleSearch = false
        const params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
        this.$store.dispatch(`${this.store}/getAll`, params)
      } else if (this.filtroBuscar.length > 0 && this.store === 'contactos') {
        this.$store.commit('contactos/setSearchContactKeep', '')
        this.$set(this, 'filtroBuscar', '')
        this.$set(this, 'selectedPage', 1)
        this.showStyleSearch = false
        const params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro, idcuenta: this.idCuenta } }, this.query || {})
        this.$store.dispatch(`${this.store}/getAll`, params)
      } else if (this.filtroBuscar.length > 0 && this.store === 'cuentas') {
        this.$store.commit('cuentas/setSearchAccountKeep', '')
        this.$set(this, 'filtroBuscar', '')
        this.$set(this, 'selectedPage', 1)
        this.showStyleSearch = false
        const params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro } }, this.query || {})
        this.$store.dispatch(`${this.store}/getAll`, params)
      } else if (this.filtroBuscar.length > 0 && this.store === 'usuarios') {
        this.$store.commit('usuarios/setSearchUserKeep', '')
        this.$set(this, 'filtroBuscar', '')
        this.$set(this, 'selectedPage', 1)
        this.showStyleSearch = false
        const params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro } }, this.query || {})
        this.$store.dispatch(`${this.store}/getAll`, params)
      } else if (this.filtroBuscar.length > 0 && this.store === 'respuestaspredefinidas') {
        this.$store.commit('respuestaspredefinidas/setSearchRespuestaspredefinidasKeep', '')
        this.$set(this, 'filtroBuscar', '')
        this.$set(this, 'selectedPage', 1)
        this.showStyleSearch = false
        const params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro } }, this.query || {})
        this.$store.dispatch(`${this.store}/getAll`, params)
      } else if (this.filtroBuscar.length > 0 && this.store === 'catalogodocumentos') {
        this.$set(this, 'filtroBuscar', '')
        this.$set(this, 'selectedPage', 1)
        const params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro } }, this.query || {})
        this.$store.dispatch(`${this.store}/getAll`, params)
      }
    },
    changeSearchEnter () {
      this.emitResetIntervalFromChild()
      if (this.filtroBuscar === null || this.filtroBuscar === '' || this.filtroBuscar.length === 0) {
        this.newSearchEnter()
      }
    },
    newSearchEnter () {
      this.emitResetIntervalFromChild()

      this.isSearchingCasesButton = false

      if (this.newQuery !== false && (this.store === 'listacorreos' || this.store === 'respuestaspredefinidas')) {
        let params = ''
        if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
          params = Object.assign({}, { force: true, query: this.newQuery }, {})
        } else if (this.filtroBuscar.length === 0) {
          params = Object.assign({}, { force: true, query: this.newQuery }, {})
        }
        const returnData = this.$store.dispatch(`${this.store}/getAll`, params)
          .then((data) => {
            if (this.pagination == null || this.pagination == undefined) {
              return []
            } else {
              const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
              if (this.selectedPage > newPages && newPages > 0) {
                this.selectedPage = 1
                params = Object.assign({}, { force: true, query: this.newQuery }, {})
                this.$store.dispatch(`${this.store}/getAll`, params)
              }
            }
          })
          .catch(() => this.$notification('error'))
        return returnData
      } else {
        let params = ''
        this.$set(this, 'selectedPage', 1)
        if (this.store === 'casos' || this.store === 'casos/grupo' || this.store === 'casos/gruposkill' || this.store === 'contactos/casos' || this.store === 'cuentas/casos') {
          this.isSearchingCasesButton = true;

          this.$store.commit('casos/setSearchCaseKeep', this.filtroBuscar)
          this.$store.commit('casos/setRouterSearch', this.$route.path)
          this.$store.commit('casos/setStoreSearch', this.store)
          this.showStyleSearch = !!this.filtroBuscar
        } else if (this.store === 'contactos') {
          this.$store.commit('contactos/setSearchContactKeep', this.filtroBuscar)
          this.$store.commit('contactos/setRouterSearch', this.$route.path)
          this.$store.commit('contactos/setStoreSearch', this.store)
          this.showStyleSearch = !!this.filtroBuscar
        } else if (this.store === 'cuentas') {
          this.$store.commit('cuentas/setSearchAccountKeep', this.filtroBuscar)
          this.$store.commit('cuentas/setRouterSearch', this.$route.path)
          this.$store.commit('cuentas/setStoreSearch', this.store)
          this.showStyleSearch = !!this.filtroBuscar
        } else if (this.store === 'usuarios') {
          this.$store.commit('usuarios/setSearchUserKeep', this.filtroBuscar)
          this.showStyleSearch = !!this.filtroBuscar
        } else if (this.store === 'respuestaspredefinidas') {
          this.$store.commit('respuestaspredefinidas/setSearchRespuestaspredefinidasKeep', this.filtroBuscar)
          this.showStyleSearch = !!this.filtroBuscar
        }

        if ((this.filtroBuscar !== null || this.filtroBuscar !== '') && this.filtroBuscar.length > 2) {
          params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
        } else if (this.filtroBuscar.length === 0) {
          params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
        }
        const returnData = this.$store.dispatch(`${this.store}/getAll`, params)
          .then(() => {
            if (this.pagination == null || this.pagination == undefined) {
              return []
            } else {
              if (this.pagination.size > 0) {
                const newPages = Math.ceil(this.pagination.size / this.rowsOnPage)
                if (this.selectedPage > newPages) {
                  this.selectedPage = 1
                  params = Object.assign({}, { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrobuscar: this.filtroBuscar, filtro: this.filtro, idcontacto: this.idContacto, idcuenta: this.idCuenta } }, this.query || {})
                  this.$store.dispatch(`${this.store}/getAll`, params)
                }
              }
            }
          })
          .catch(() => this.$notification('error'))
          .finally(() => {
            this.isSearchingCasesButton = false;
          });

        return returnData
      }
    },
    selectTipoFilterLog () {
      this.selectedPage = 1
      this.$store.dispatch('loggeneral/getAll', { force: true, query: { pagina: this.selectedPage, cantidad: this.rowsOnPage, filtrolog: this.filterTypeLog } })
    },
    isListaCorreos () {
      const e = document.getElementsByClassName('listcorreos')
      const f = document.getElementById('listCorreosFromCasoFlag')
      if (e && f) {
        this.listcorreos = true
      }
    },
    startChangePathListener() {
      let currentPath = window.location.pathname;
      if (currentPath === '/casos' || currentPath === '/casos/buscar' || currentPath === '/casos/supervisar' || currentPath === '/casos/supervisarHistorico' || currentPath === '/casos/sinasignar' || currentPath === '/casos/cerrados' || currentPath === '/casos/espera' || currentPath === '/casos/historico' || currentPath === '/casos/geolocalizacion') {
        let getParameter = this.refreshCases;
        if (getParameter === 'SI') {
          window.addEventListener(
            'popstate', this.startInterval(), true
          )
        }
      }
    },
    startInterval() {
      if (!this.intervalId) {
        let currentPath = window.location.pathname;
        if (currentPath === '/casos' || currentPath === '/casos/buscar' || currentPath === '/casos/supervisar' || currentPath === '/casos/supervisarHistorico' || currentPath === '/casos/sinasignar' || currentPath === '/casos/cerrados' || currentPath === '/casos/espera' || currentPath === '/casos/historico' || currentPath === '/casos/geolocalizacion') {
          let stringMinutes = this.refreshCasesInterval;
          let minutes = parseInt(stringMinutes);
          let minutesToMilliseconds = minutes * 60 * 1000;
          this.intervalId = setInterval(() => {
            this.getAll();
          }, minutesToMilliseconds);
        }
      }
    },
    stopInterval() {
        clearInterval(this.intervalId);
        this.intervalId = null;
    },
    resetInterval(){
      if(this.intervalId){
        clearInterval(this.intervalId);
        this.intervalId = null;
        this.startChangePathListener()
      }
    },
    emitResetIntervalFromChild() {
      let currentPath = window.location.pathname;
      if (currentPath === '/casos/buscar' || currentPath === '/casos/supervisarHistorico' || currentPath === '/casos/sinasignar' || currentPath === '/casos/cerrados' || currentPath === '/casos/espera' || currentPath === '/casos/historico' || currentPath === '/casos/geolocalizacion') {
        this.resetInterval()
      } else if (currentPath === '/casos' || currentPath === '/casos/supervisar') {
        this.$emit('emitResetIntervalFromDTSP')
      }
    }
    },
  mounted () {
    if (this.purecloud === true) {
      if (this.store !== 'cuentas/casos' && this.store !== 'contactos/casos') {
        this.filtroBuscar = this.$route.params.contactDni
      }
    }
    if (this.autoInit) {
      if (this.store === 'casos' || this.store === 'casos/grupo' || this.store === 'casos/gruposkill' || this.store === 'contactos/casos' || this.store === 'cuentas/casos') {
        if (this.$store.state.casos.searchCaseKeep && this.$route.path === this.$store.state.casos.routerSearch) {
          if (this.store === this.$store.state.casos.storeSearch) {
            this.filtroBuscar = this.$store.state.casos.searchCaseKeep
            this.showStyleSearch = !!this.filtroBuscar
          }
        }

        if (this.$store.state.contactos.searchContactKeep && this.store === 'casos') {
          this.$store.commit('contactos/setSearchContactKeep', '') // limpiar búsqueda al ir de contacto a bandejas de casos.
        } else if (this.$store.state.cuentas.searchAccountKeep && this.store === 'casos') {
          this.$store.commit('cuentas/setSearchAccountKeep', '') // limpiar búsqueda al ir de cuentas a bandejas de casos.
        } else if (this.$store.state.usuarios.searchUserKeep && this.store === 'casos') {
          this.$store.commit('usuarios/setSearchUserKeep', '') // limpiar búsqueda al ir de usuarios a bandejas de casos.
        }
      } else if (this.store === 'contactos') {
        if (this.$store.state.contactos.searchContactKeep && this.$route.path === this.$store.state.contactos.routerSearch) {
          if (this.store === this.$store.state.contactos.storeSearch) {
            this.filtroBuscar = this.$store.state.contactos.searchContactKeep
            this.showStyleSearch = !!this.filtroBuscar
          }
        }
        if (this.$store.state.casos.searchCaseKeep && this.$route.path === '/contactos') {
          this.$store.commit('casos/setSearchCaseKeep', '') // limpiar búsqueda al ir de casos contactos a bandeja de contacto.
        }
        if (this.$store.state.cuentas.searchAccountKeep && this.store === 'contactos') {
          this.$store.commit('cuentas/setSearchAccountKeep', '') // limpiar búsqueda al ir de cuentas a bandeja de contactos.
        }
        if (this.$store.state.usuarios.searchUserKeep && this.store === 'contactos') {
          this.$store.commit('usuarios/setSearchUserKeep', '') // limpiar búsqueda al ir de usuarios a bandeja de contactos.
        }
      } else if (this.store === 'cuentas') {
        if (this.$store.state.cuentas.searchAccountKeep && this.$route.path === this.$store.state.cuentas.routerSearch) {
          if (this.store === this.$store.state.cuentas.storeSearch) {
            this.filtroBuscar = this.$store.state.cuentas.searchAccountKeep
            this.showStyleSearch = !!this.filtroBuscar
          }
        }
        if (this.$store.state.casos.searchCaseKeep && this.$route.path === '/cuentas') {
          this.$store.commit('casos/setSearchCaseKeep', '') // limpiar búsqueda al ir de casos cuentas a bandeja de cuentas.
        }
        if (this.$store.state.contactos.searchContactKeep && this.store === 'cuentas') {
          this.$store.commit('contactos/setSearchContactKeep', '') // limpiar búsqueda al ir de contactos a bandeja de cuentas.
        }
        if (this.$store.state.usuarios.searchUserKeep && this.store === 'cuentas') {
          this.$store.commit('usuarios/setSearchUserKeep', '') // limpiar búsqueda al ir de usuarios a bandeja de cuentas.
        }
      } else if (this.store === 'usuarios') {
        if (this.$store.state.usuarios.searchUserKeep) {
          this.filtroBuscar = this.$store.state.usuarios.searchUserKeep
          this.showStyleSearch = !!this.filtroBuscar
        }

        if (this.$store.state.casos.searchCaseKeep && this.$route.path === '/usuarios') {
          this.$store.commit('casos/setSearchCaseKeep', '') // limpiar búsqueda al ir de casos contactos a bandeja de usuarios.
        }
        if (this.$store.state.cuentas.searchAccountKeep && this.store === 'usuarios') {
          this.$store.commit('cuentas/setSearchAccountKeep', '') // limpiar búsqueda al ir de cuentas a bandeja de usuarios.
        }
        if (this.$store.state.contactos.searchContactKeep && this.store === 'usuarios') {
          this.$store.commit('contactos/setSearchContactKeep', '') // limpiar búsqueda al ir de contactos a bandeja de usuarios.
        }
      } else {
        if (this.store !== 'respuestaspredefinidas' && this.store !== 'listacorreos') {
          this.$store.commit('casos/setSearchCaseKeep', '')
          this.$store.commit('casos/setRouterSearch', '')
          this.$store.commit('casos/setStoreSearch', '')

          this.$store.commit('contactos/setSearchContactKeep', '')
          this.$store.commit('contactos/setRouterSearch', '')
          this.$store.commit('contactos/setStoreSearch', '')

          this.$store.commit('cuentas/setSearchAccountKeep', '')
          this.$store.commit('cuentas/setRouterSearch', '')
          this.$store.commit('cuentas/setSearchAccountKeep', '')

          this.$store.commit('usuarios/setSearchUserKeep', '')
          this.showStyleSearch = false
        } else if (this.store === 'respuestaspredefinidas' && !this.respList || this.store === 'listacorreos' && !this.emailList) {
          this.$store.commit('casos/setSearchCaseKeep', '')
          this.$store.commit('casos/setRouterSearch', '')
          this.$store.commit('casos/setStoreSearch', '')

          this.$store.commit('contactos/setSearchContactKeep', '')
          this.$store.commit('contactos/setRouterSearch', '')
          this.$store.commit('contactos/setStoreSearch', '')

          this.$store.commit('cuentas/setSearchAccountKeep', '')
          this.$store.commit('cuentas/setRouterSearch', '')
          this.$store.commit('cuentas/setSearchAccountKeep', '')

          this.$store.commit('usuarios/setSearchUserKeep', '')
          this.showStyleSearch = false
        }
      }
      this.getAll().then(() => this.cancel())
    }
    this.isListaCorreos()
  },
  destroyed() {
    if (this.intervalId) {
      window.removeEventListener(
        'popstate', this.startInterval(), true
      )
      this.stopInterval()
    }
  }
}
</script>
